import React from 'react';
import {Camera} from 'react-camera-pro';
import './App.css';
import NavBarLayout from './NavbarLayout';
import { useNavigate } from 'react-router-dom';
import { RiCircleLine } from "react-icons/ri";
import IconButton from '@mui/material/IconButton';

function CameraScreen() {
  const camera = React.useRef(null);
  const navigate = useNavigate();

  return (
    <NavBarLayout title="Add Manually" onBackButtonClicked={() => navigate("/addmethods")} active={1}>
      <div style={{position: "relative", height: "100%", width: "100%"}}>
        <Camera ref= {camera} facingMode="environment" />
        <div style={{bottom: "10px", left: "50%", position: 'absolute', transform: "translate(-50%, 0)"}} >
          <IconButton onClick={() => navigate("/manualaddresults")} > 
            <RiCircleLine  color="white" size="6rem"/>
          </IconButton>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default CameraScreen;